import { format } from 'date-fns';

import { APIConfiguration } from '@savgroup-front-common/configuration';
import { LANGUAGES } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  intl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  OwnerSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}anonymous/import/orders`;

interface CreateOrderPayload {
  tenantId: string;
  sellerId: string;
  orderReference: string;
  purchaseDate?: Date;
  owner: Partial<OwnerSummary>;
}

async function createAnonymousOrder({
  tenantId,
  owner,
  sellerId,
  orderReference,
  purchaseDate,
}: CreateOrderPayload): Promise<BackResponse<Location> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<Location>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        tenantId,
        owner,
        sellerId,
        orderReference,
        purchaseDate: purchaseDate
          ? format(purchaseDate, 'yyyy-MM-dd')
          : undefined,
        preferredLanguage: intl?.locale ?? LANGUAGES.FR,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default createAnonymousOrder;
